export const formatRate = ({
  amount,
  places = 0
}: {
  amount: number
  places?: number
}) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: places,
    maximumFractionDigits: places
  }).format(amount)

export const formatNumber = ({
  amount,
  places = 0,
  notation
}: {
  amount: number
  places?: number
  notation?: 'compact' | 'standard'
}) =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: amount > 999999 ? Math.max(1, places) : places,
    notation: !notation ? (amount > 999999 ? 'compact' : 'standard') : notation
  }).format(amount)

export const formatCurrency = ({
  amount,
  notation,
  showCents = true,
  places = 2
}: {
  amount: number
  notation?: 'compact' | 'standard'
  showCents?: boolean
  places?: number
}) => {
  if (!amount) return '$0.00'

  const isLargeNumber = amount > 999999
  const isWholeNumber = amount % 1 === 0

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: showCents
      ? places
      : isWholeNumber || isLargeNumber
      ? 0
      : places,
    maximumFractionDigits: places,
    notation: !notation ? (isLargeNumber ? 'compact' : 'standard') : notation
  }).format(amount)
}

export const formatOrdinal = (day: number): string => {
  if (day < 1 || day > 31) return `${day}`

  const j = day % 10
  const k = day % 100

  if (j === 1 && k !== 11) {
    return `${day}st`
  }
  if (j === 2 && k !== 12) {
    return `${day}nd`
  }
  if (j === 3 && k !== 13) {
    return `${day}rd`
  }
  return `${day}th`
}
